var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 23,
    viewBox: "0 0 20 23",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#000",
      strokeWidth: 1.5,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(1 1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 2.475 11.25 4.5 6.187-2.475-11.25-4.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 2.475v13.5l11.25 4.5v-13.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.437 4.525v13.5l-6.187 2.475v-.025-13.5l6.187-2.475"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7.03543007 7.225-2.78543007 1.11417203",
    transform: "matrix(-1 0 0 1 11.28543 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubBox);
export default __webpack_public_path__ + "static/media/sub_box.123d5a8946198e371986ba7191609398.svg";
export { ForwardRef as ReactComponent };